import { createSlice } from '@reduxjs/toolkit'


// Reducer Thunk

const initialState = {
    isLoading: false
}

const LoadingSlice = createSlice({
    name: 'Loading',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.isLoading = action.payload
            console.log(state.isLoading)
        }
        
    },
    extraReducers: (builder) => {
        
    }
})

// Reducer
const LoadingReducer = LoadingSlice.reducer

// Selector
export const LoadingSelector = (state) => state.LoadingReducer
// Action export
export const {
    setLoading
} = LoadingSlice.actions

// Export reducer
export default LoadingReducer